import type { JSX } from "react";

import { Drawer as BaseDrawer } from "@base-ui/react/drawer";

import type { DrawerProps } from "./Drawer.types";

export function Drawer({ ...props }: DrawerProps): JSX.Element {
  return <BaseDrawer.Root data-slot="drawer" {...props} />;
}
